// extracted by mini-css-extract-plugin
export default {"container":"ImageSlider_container__RstI-","slideimg":"ImageSlider_slideimg__+9lCe","slider":"ImageSlider_slider__uk6Ru","sliderButton":"ImageSlider_sliderButton__VJiMo"};